import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env";
import { API_ENDPOINTS } from "../../secure-blockchain-api-endpoints";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { SmartContractAccessFlow } from "@aptsi-types";

interface AccessFlowResponse {
    data?: SmartContractAccessFlow[];
    chaincodes?: SmartContractAccessFlow[];
}

@Injectable({
    providedIn: 'root'
})
export class SmartContractAccessFlowService {

    private baseUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    getChaincodesWithAccessFlow(
        orgId: string | null
    ): Observable<SmartContractAccessFlow[]> {

        return this.http.post<AccessFlowResponse>(
            `${this.baseUrl}${API_ENDPOINTS.ACCESS_FLOW.GET}`,
            { organizationId: orgId }
        ).pipe(
            map(res => {
                // normalize response safely
                if (Array.isArray(res)) return res;
                if (Array.isArray(res?.data)) return res.data;
                if (Array.isArray(res?.chaincodes)) return res.chaincodes;
                return [];
            })
        );
    }

    searchChaincodesWithAccessFlow(
        currentPage: number,
        searchText: string,
        category: string,
        orgId: string | null
    ): Observable<SmartContractAccessFlow[]> {

        return this.http.post<AccessFlowResponse>(
            `${this.baseUrl}${API_ENDPOINTS.ACCESS_FLOW.SEARCH_ALL}`,
            { currentPage, searchText, category, organizationId: orgId }
        ).pipe(
            map(res => {
                // normalize response safely
                if (Array.isArray(res)) return res;
                if (Array.isArray(res?.data)) return res.data;
                if (Array.isArray(res?.chaincodes)) return res.chaincodes;
                return [];
            })
        );
    }

    getMissingAccessFlows(orgId: string): Observable<any[]> {
        return this.http.post<any[]>(
            `${this.baseUrl}${API_ENDPOINTS.ACCESS_FLOW.MISSING}`,
            { organizationId: orgId }
        );
    }

    createAccessFlows(payload: any[]) {
        return this.http.post(
            `${this.baseUrl}${API_ENDPOINTS.ACCESS_FLOW.CREATE}`,
            payload
        );
    }


    searchAccessFlows(
        orgId: string,
        page: number,
        category: string,
        value: string
    ): Observable<any> {

        return this.http.post<any>(
            `${this.baseUrl}/secureblockchain/accessflow/search?page=${page}&category=${category}&value=${value}`,
            {
                organizationId: orgId
            }
        ).pipe(
            map(res => {
                const wrapper = res["Resource retrieved successfully"];

                return {
                    data: wrapper?.data || [],
                    total: wrapper?.total || 0,
                    totalPages: wrapper?.totalPages || 0,
                    currentPage: wrapper?.currentPage || 0
                };
            })
        );
    }

    getRemainingAssetsAccessFlow(
        currentPage: number,
        organizationId: string
    ): Observable<any[]> {

        return this.http
            .post<{ assets: any[] }>(
                `${this.baseUrl}${API_ENDPOINTS.ASSET.FETCHREMACCESSFLOWASSETS}`,
                {
                    currentPage,
                    organizationId
                }
            )
            .pipe(
                map(response => response.assets)
            );
    }

    getRemainingAssetsAccessFlowSearch(
        currentPage: number,
        searchText: string,
        filterByHeader: string,
        organizationId: string
    ): Observable<any[]> {

        return this.http
            .post<{ assets: any[] }>(
                `${this.baseUrl}${API_ENDPOINTS.ASSET.SEARCHREMACCESSFLOWASSETS}`,
                {
                    currentPage,
                    searchText,
                    filterByHeader,
                    organizationId
                }
            )
            .pipe(
                map(response => response.assets)
            );
    }

    generateRemainingAssetsAccessFlow(
        payload: any[]
    ): Observable<any> {

        return this.http.post(
            `${this.baseUrl}${API_ENDPOINTS.ASSET.GENERATEREMAININGASSETSACCESSFLOW}`,
            {
                payload
            }
        );
    }
}